"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripValueFromHighlight = exports.getGoogleMapLink = void 0;
var getGoogleMapLink = function (query) { return "https://www.google.com/maps/search/?api=1&query=".concat(query); };
exports.getGoogleMapLink = getGoogleMapLink;
var stripValueFromHighlight = function (highlight) {
    return highlight.replace('<span class="highlight-filter-match">', '').replace('</span>', '');
};
exports.stripValueFromHighlight = stripValueFromHighlight;
